import {Directive, ElementRef, HostListener, Input, NgModule} from '@angular/core';


@Directive({
	selector: '[libScrollClass]'
})

export class ScrollClassDirective {
	@Input()
	offsetElementId: string;

	@Input()
	directiveClassName: string;

	offsetElement: HTMLElement;

	constructor(private el: ElementRef) {
	}

	@HostListener('window:scroll')
	onScroll() {
		if (!this.offsetElement) {
			this.offsetElement = document.getElementById(this.offsetElementId);
		}
		if (this.isInViewport()) {
			(this.el.nativeElement as HTMLElement).classList.remove(this.directiveClassName);
		} else {
			(this.el.nativeElement as HTMLElement).classList.add(this.directiveClassName);
		}
	}

	isInViewport() {
		return (window.pageYOffset > this.offsetElement.offsetTop + this.offsetElement.offsetHeight);
	}
}
@NgModule({
	declarations: [ScrollClassDirective],
	exports: [ScrollClassDirective]
})
export class ScrollClassDirectiveModule {}
